import axios from "axios";
import { apiAddress } from "../../config/server";
import { IVenue } from "../../types/venue/Venue";

export default class VenuesApi {
  static VenuesApiAddress = `${apiAddress}/api/venue/`;

  static GetAllVenuesApiAddress = VenuesApi.VenuesApiAddress;

  static getAllVenues(): Promise<IVenue[]> {
    return axios.get(this.GetAllVenuesApiAddress).then((response) => {
      if (response.status == 200 && response.data.success) {
        return response.data.venues;
      }
      throw new Error(response.data.message);
    });
  }
}
